import { topicListAPI } from '@/providers/apis/topic-list/topic-list';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'delete-topic',
})

export default class CreateTopic extends Vue {
    @Prop()
    public selectedTopic: any;
    public errorMessage: string | null = null;

    public async onConfirmDelete() {
        try {
            await topicListAPI.deleteTopic(this.selectedTopic.id);
            this.$emit('onGoBack', true); 
        } catch (error) {
            this.errorMessage = "Failed to delete topic. Please try again.";
            this.$emit('onGoBack', false);
        }
    }

    public onClickCancel() {
        this.$emit('onGoBack');
    }
}